export const URL_PARAM_CUSTOMER_ID = 'cid'
